import { render, staticRenderFns } from "./img-empty.vue?vue&type=template&id=11c4e560&"
import script from "./img-empty.vue?vue&type=script&lang=js&"
export * from "./img-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports